module.exports = __webpack_public_path__ + "static/icons/icon-resort-manager-logo--color-5f0afa5f8e6daedaac0dcf558e6c62d0.svg";